import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-createnewmasterkeyuser',
  templateUrl: './createnewmasterkeyuser.component.html',
  styleUrls: ['./createnewmasterkeyuser.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CreatenewmasterkeyuserComponent {

}
